import React, {useState, useEffect} from 'react'
import useDebounce from '../../context/hooks/useDebounce';
import { useNavigate } from 'react-router-dom';
import useAxiosPrivate from '../../context/hooks/useAxiosPrivate';
import {Table, Spinner, ButtonGroup, ToggleButton, Row, Col} from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import ListPaginator from '../../components/ListPaginator';
import '../../appstyles/ClientsCSS/ClientsList.css';
import ExcelQuoteRequest from '../../components/ExcelQuoteRequest';
import PermissionWrapper from '../../context/PermissionWrapper';

function OrderList() {
  const axiosInstance = useAxiosPrivate();
  const [orders, setOrders] = useState([]);
  const [status, setStatus] = useState('Pendiente');
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState('');
  const debouncedSearch = useDebounce(search, 700);
  const navigate = useNavigate();

  const fetchOrders = (page, pageSize, searchQuery) => {
    setLoading(true)
    const url = searchQuery
      ? `api/quote/?page=${page}&size=${pageSize}&status=${status}&search=${searchQuery}`
      : `api/quote/?page=${page}&size=${pageSize}&status=${status}`;

    axiosInstance.get(url)
      .then(response => {
        setOrders(response.data.data);
        setTotalPages(response.data.totalPages); 
      })
      .catch(error => {
        console.log('Failed to fetch requests', error);
      })
      .finally(() => {
        setLoading(false)
      });
  }

  const handleFilterChange = (event) => {
    setStatus(event.target.value);
  };

  const radios = [
    { name: 'Pendiente', value: 'Pendiente' },
    { name: 'Aprobado', value: 'Aprobado' },
    { name: 'Rechazado', value: 'Rechazado' }
  ];

  useEffect(() => {
      fetchOrders(currentPage, rowsPerPage, debouncedSearch);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, status, rowsPerPage, debouncedSearch]);

  const handleRowClick = (quoteId) => {
  navigate(`/quote/details/${quoteId}`);
  };

  const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
  };


  return (
    <div className='maestros-list'>
      <h2>Tabla de Cotizaciones</h2>
      <hr />
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Form.Control
          style={{ width: '50%' }}
          type="search"
          placeholder="Buscar por cliente, proveedor o ID"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>
      <div className='filter-container'>
        <ButtonGroup toggle style={{width: '20%'}}>
          {radios.map((radio, idx) => (
            <ToggleButton
              key={idx}
              id={`radio-${idx}`}
              type="radio"
              variant='outline-secondary'
              name="radio"
              value={radio.value}
              checked={status.toString() === radio.value}
              onChange={(e) => handleFilterChange(e)}
            >
              {radio.name}
            </ToggleButton>
          ))}
        </ButtonGroup>
      </div>

      {loading ? ( 
          <div className='loading-container'>
          <p style={{fontFamily: 'Roboto, sans-serif'}}>Cargando...</p>
          <Spinner animation="border" variant="info" style={{width: '4.5rem', height: '4.5rem'}} />
          </div>
      ) : (  
      <Table striped bordered hover responsive
        style={{overflowY: 'auto'}}
      >
          <thead>
              <tr>
                  <th>ID</th>
                  <th>Cliente</th>
                  <th>Proveedor</th>
                  <th>Producto</th>
                  <th>Fabricante</th>
                  <th>Incoterm</th>
                  <th>Estado</th>
                  <th>Pedido</th>
                  <th>Fecha Solicitada</th>
                  <th>Fecha de Creación</th>
                  <th>Creado por</th>
              </tr>
          </thead>
          <tbody>
              {orders.map( order => (
                  <tr key={order.quote_id} onClick={() => handleRowClick(order.quote_id)} style={{ cursor: 'pointer' }}>
                      <td>{order.quote_id}</td>
                      <td>{order.client_name}</td>
                      <td>{order.supplier_name}</td>
                      <td>
                        {order.products.length > 0 ? order.products[0].product_name : ''}
                        {order.products.length > 1 ? ', ...' : ''}
                      </td>
                      <td>
                        {order.products.length > 0 ? order.products[0].product_manufacturer : ''}
                        {order.products.length > 1 ? ', ...' : ''}
                      </td>
                      <td>{order.incoterm}</td>
                      <td>{order.status}</td>
                      <td>{order.products.length > 1 ? 'Combinado' : 'Individual'}</td>
                      <td>{order.requested_delivery_date}</td>
                      <td>{order.requested_date}</td>
                      <td>{order.created_by ? order.created_by : 'N/A' }</td>
                  </tr>
              ))}
          </tbody>
      </Table>
      )}
      <Row style={{ alignItems: 'center', marginTop: '1.5rem' }}>
        <Col md={6} style={{ display: 'flex', alignItems: 'center' }}>
          <PermissionWrapper feature="cotizaciones" action="excel">
            <ExcelQuoteRequest status={status} label={`Exportar Excel`} />
          </PermissionWrapper>
        </Col>
        <Col md={6} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          <ListPaginator
            currentPage={currentPage}
            totalPages={totalPages}
            rowsPerPage={rowsPerPage}
            onPageChange={handlePageChange}
            onRowsPerPageChange={value => {
              setRowsPerPage(value);
              setCurrentPage(1);
            }}
          />
        </Col>
      </Row>
    </div>
  )
}

export default OrderList